module.exports = [{"id":1938,"slug":"euro-i","title":"Euro I"},{"id":2018,"slug":"euro-ii","title":"Euro II"},{"id":2019,"slug":"euro-iii","title":"Euro III"},{"id":2020,"slug":"euro-iv","title":"Euro IV"},{"id":2021,"slug":"euro-v","title":"Euro V"},{"id":74153,"slug":"euro-vi","title":"Euro VI"}]


//////////////////
// WEBPACK FOOTER
// ./src/shared/constants/json/ecoTypes.json
// module id = 1159
// module chunks = 49